module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_instant_messaging-330047056c29384f15544705865929a4.svg";